import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";
import { PageHeader } from "../components/site/PageHeader";
import { ContactBlock } from "../components/site/ContactSection";
import { SectionTitle } from "../components/site/SectionTitle";

export default function ContactPage() {
  const crumbs = [{ to: "/", label: "Ana Sayfa" }, { to: "/iletisim", label: "İletişim" }];
  return (
    <>
      <Seo
        title="Lunessa Spa Masaj İletişim | Sivas"
        description="Lunessa Spa Masaj Sivas iletişim: 0535 795 20 58, WhatsApp randevu, Kızılırmak 27. Sokak No:2B Merkez/Sivas. Yol tarifi alın, hemen randevu oluşturun."
        path="/iletisim"
        breadcrumbs={crumbs}
      />
      <PageHeader eyebrow="İletişim" h1="Lunessa Spa Masaj Sivas İletişim" intro="Randevu, kampanya ve hizmetlerimiz hakkında bilgi almak için bize dilediğiniz kanaldan ulaşın." image="/images/lunessa-sivas-spa-salonu-dis-cephe.webp" imageAlt="lunessa-sivas-spa-masaj-iletisim" crumbs={crumbs} />
      <section className="container-lux py-16 lg:py-24" data-testid="contact-page">
        <ContactBlock />
      </section>
      <section className="container-lux max-w-4xl pb-20 lg:pb-28">
        <SectionTitle eyebrow="Randevu" title="Randevu Nasıl Alınır?" />
        <div className="prose-lux -mt-4">
          <p>
            Lunessa Spa Masaj’da randevu oluşturmak için 0535 795 20 58 numaralı telefondan bizi arayabilir ya da WhatsApp üzerinden mesaj gönderebilirsiniz. Mesajınızda tercih ettiğiniz hizmeti ve size uygun gün ile saati belirtmeniz, randevunuzu daha hızlı planlamamıza yardımcı olur.
          </p>
          <p>
            Salonumuz Kızılırmak Mahallesi 27. Sokak No:2B, Merkez/Sivas adresindedir. Haritadaki yol tarifi bağlantısıyla bulunduğunuz yerden kolayca ulaşabilirsiniz. Hizmetlerimizi incelemek için <Link to="/masaj-hizmetleri">masaj hizmetleri</Link>, salonumuzu tanımak için <Link to="/sivas-masaj-salonu">Sivas masaj salonu</Link> sayfalarımıza göz atabilirsiniz.
          </p>
        </div>
      </section>
    </>
  );
}
